import { render, staticRenderFns } from "./ModalBackofficeCancelarOrcamento.vue?vue&type=template&id=0b329a0d&scoped=true"
import script from "./ModalBackofficeCancelarOrcamento.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeCancelarOrcamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b329a0d",
  null
  
)

export default component.exports